import androidInstance from './android'
import iosInstance from './ios';

class Native {
    constructor(platform) {
        this.platform = platform;
        window.BSCallback = {

        }
        window.nativeCallback = {}
    }
    getGameInfo(gameID) {
        if (this.platform == 1) {
            return iosInstance.getGameInfo(gameID);
        } else {
            return androidInstance.getGameInfo(gameID);
        }
    }
    getScanResult() {
        if (this.platform == 1) {
            return iosInstance.getScanResult();
        } else {
            return androidInstance.getScanResult();
        }
    }
    getAppInfo() {
        if (this.platform == 1) {
            return iosInstance.getAppInfo();
        } else {
            return androidInstance.getAppInfo();
        }
    }
    download(gameID, url, version) {
        if (this.platform == 1) {
            return iosInstance.download(gameID, url, version);
        } else {
            return androidInstance.download(gameID, url, version);
        }
    }
    setData(key, value) {
        if (this.platform == 1) {
            iosInstance.setData(key, value)
        } else {
            androidInstance.setData(key, value);
        }
    }
    removeData(key) {
        if (this.platform == 1) {
            iosInstance.removeData(key);
        } else {
            androidInstance.removeData(key);
        }
    }
    getData(key) {
        if (this.platform == 1) {
            return iosInstance.getData(key);
        } else {
            return androidInstance.getData(key);
        }
    }
    openURL(url) {
        if (this.platform == 1) {
            iosInstance.openURL(url);
        } else {
            androidInstance.openURL(url);
        }
    }

}

export default Native;